/*
    Usage:
    TODO: add notes

*/

const active = function (el, binding, vnode) {

    // Options for Interections
    const options = { threshold: 1.0 }

    const id = el.id  ?? ""
    const anchorLink = document.querySelector(`.js-jumpLink-${ id }`)

    // Locate element to watch
    if(id.length && anchorLink){

        // Initiate the observer
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    document.querySelectorAll('.js-jumpLink').forEach((link) => link.classList.remove('-active'))
                    document.querySelector(`.js-jumpLink-${ id }`).classList.add('-active')
                }
            })

        }, options);

        // Observe the el
        observer.observe(el);
    }
}

export default active